import { stringToDate } from '@hc-frontend/utils'

/**
 * @deprecated - This function is deprecated and should not be used in new code.
 * It is kept for backward compatibility. The name does not accurately reflect its functionality.
 * Use `utils/date/format-month` or similar utility/date functions instead.
 */
export default function getPeriodRange(start: string) {
  const sDate = stringToDate(start)
  const startParts = sDate.toDateString().split(' ')

  return {
    slash: {
      start
    },
    monthName: {
      start: `${startParts[1]} ${+startParts[2]}, ${startParts[3]}`
    }
  }
}
